import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tag } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import theme from 'shared/constants/theme.json';
import messages from './messages';
import './chart-header.less';

export const getTitle = (title, translate) => {
  const { formatMessage } = useIntl();
  return translate && messages[title] ? formatMessage(messages[title]) : title;
};

const ChartHeader = ({ title, translate, active }) => {
  if (!title) {
    return null;
  }

  return (
    <h2 className="chart-header__title">
      <span dangerouslySetInnerHTML={{ __html: getTitle(title, translate) }} />
      {active === false && <Tag icon={<ExclamationCircleOutlined />} color={theme['warning-color']}><FormattedMessage {...messages.inactive} /></Tag>}
    </h2>
  );
};

export default ChartHeader;
